import {
  Box,
  IconButton,
  TableCell,
  TableRow,
  Typography,
} from "@material-ui/core";
import { FC, useState } from "react";
import { useStyles } from "./styles";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import { FalconStandardData, FalconTableRow } from "types/Falcon";
import { TABLE_SIDE_ROWS_TWO } from "./falconTable";
import { FalconRow } from "./FalconRow";

interface PropsType {
  headColumns: any;
}

const FalconCollapseRow: FC<PropsType> = ({ headColumns }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const { falconData } = useTypeSelectors((state) => state.falconTable);

  const dataList = TABLE_SIDE_ROWS_TWO?.filter((row: FalconTableRow) =>
    falconData?.standardList?.some(
      (data: FalconStandardData) =>
        data?.role === row?.role &&
        row?.hour?.includes(data?.role_hours) &&
        row?.vans?.includes(
          data?.van__fleet_size ? data?.van__fleet_size : data?.cancelled_fleet_size,
        ),
    ),
  );

  return (
    <>
      <TableRow
        className={`${classes.collapseRow} ${open && classes.activeCollapseRow} ${!open && classes.borderCellBottomThick}`}
      >
        <TableCell className={`${classes.tableCollapseCell} ${classes.borderCellTopThink}`} colSpan={2}>
          <Box className={classes.collapseLabelBox}>
            <IconButton
              className={`${classes.collapseBtn} ${open && classes.activeCollapseBtn}`}
              size="small"
              onClick={() => setOpen(!open)}
              disabled={!dataList.length}
            >
              <KeyboardArrowDown />
            </IconButton>
            <Typography className={classes.collapseLabel}>
              Non-Billed Routes ({dataList.length})
            </Typography>
          </Box>
        </TableCell>
        <TableCell
          className={`${classes.tableCell} ${classes.borderCellTopThink}`}
          colSpan={2}
        ></TableCell>
        <TableCell
          className={`${classes.tableCell} ${classes.borderCellRightDark} ${classes.borderCellTopThink}`}
          colSpan={2}
        ></TableCell>
        {headColumns?.map(() => (
          <TableCell
            className={`${classes.tableCell} ${classes.borderCellTopThink}`}
            colSpan={2}
          ></TableCell>
        ))}
        <TableCell
          className={`${classes.tableCell} ${classes.borderCellTopThink}`}
          colSpan={2}
        ></TableCell>
      </TableRow>
      <>
        {open && (
          <>
            {dataList?.map((row: FalconTableRow, index: number) => (
              <FalconRow
                tableRow={row}
                headColumns={headColumns}
                isLastCollapseRow={dataList.length - 1 === index}
                isCollapseRowActive
              />
            ))}
          </>
        )}
      </>
    </>
  );
};

export default FalconCollapseRow;
